import * as type from "../types";
import { get, patch, deleteReq, post } from './../../config/Requests';
import { setData } from './../helpers';
import { openSnackbarInfoDispatch, openSnackbarWarning, openSnackbarError } from './requestAction';
import t from "../../languages/pl";
import { driversListRoute, driversImportRoute, driversEcoChart, driversResetMobileAppKeyRoute } from './../../config/routes';

export const getDrivers = () => {
    return dispatch => {

        get(
            dispatch,
            driversListRoute,
            { },
            response => {
                response.data[1].map(driver => {
                    if(driver.kierowca_eco === 'b.d.'){
                        driver.kierowca_eco = -1;
                    }
                });
                setData(dispatch, type.SET_ALL_DRIVERS, response);
            }
        );
    };
};

export const patchDriver = (id, data) => {
    return (dispatch, getState) => {
        let driverGroup = getDriverGroup(getState, data.kierowca_grupa);
        let driver = getState().driverReducer.availableDrivers.find(element => element.kierowca_id === id);
        patch(
            dispatch,
            driversListRoute,
            { kierowca_id: id },
            data,
            () => {
                let updatedDriver = {
                    ...driver,
                    ...data,
                    kierowca_grupa: driverGroup,
                };
                dispatch({
                    type: type.UPDATE_DRIVER,
                    value: updatedDriver
                });
                openSnackbarInfoDispatch(dispatch, t.driverEditedSuccessfully);
            }
        );
    };
};

export const deleteDriver = id => {
    return dispatch => {
        deleteReq(
            dispatch,
            driversListRoute,
            { kierowca_id: id },
            () => {
                dispatch({
                    type: type.DELETE_DRIVER,
                    value: id
                });
                openSnackbarInfoDispatch(dispatch, t.driverDeletedSuccessfully);
            }
        );
    };
};

export const addDriver = data => {
    return (dispatch, getState) => {
        let driverGroup = getDriverGroup(getState, data.kierowca_grupa);
        post(
            dispatch,
            driversListRoute,
            data,
            response => {
                let newDriver = {
                    ...data,
                    kierowca_grupa: driverGroup,
                    ...response.data
                };
                dispatch({
                    type: type.ADD_DRIVER,
                    value: newDriver
                });
            }
        );
    };
};

//TODO
export const addMultipleDrivers = data => {
    return dispatch => {
        post(
            dispatch,
            driversImportRoute,
            data,
            response => console.log('response.data', response.data)
        );
    };
};

export const rfidNotValid = () => {
    return dispatch => {
        openSnackbarWarning(dispatch, t.rfidAlreadyInUse);
    };
};

export const emailNotValid = () => {
    return dispatch => {
        openSnackbarWarning(dispatch, t.incorrectEmailFormat);
    };
};

export const dataNotValid= () => {
    return dispatch => {
        openSnackbarWarning(dispatch, t.reqiredFieldsNotFilled);
    };
};

const getDriverGroup = (getState, groupId) => {
    let groups = getState().filterReducer.groupOptions;
    let driverGroup = groups.find(group => group.id === groupId);
    if(!driverGroup)
        driverGroup = {
            id: 0,
            nazwa: ""
        };
    return { id: driverGroup.id, nazwa: driverGroup.name };
};


export const getDriverEcoChart = id => {
    return dispatch => {
        get(
            dispatch,
            driversEcoChart,
            { kierowca_id: id },
            response => setData(dispatch, type.SET_DRIVER_ECO_CHART, response)
        );
    };
};

export const cleanDriverChartData = () => {
    return dispatch => {
        dispatch({
            type: type.SET_DRIVER_ECO_CHART,
            value: []
        });
    };
};

export const generateMobileKey = id => {
    return (dispatch, getState) => {
        let newDriver = getState().driverReducer.availableDrivers.find(driver => driver.kierowca_id === id);
        if(!newDriver)
            return openSnackbarError(dispatch, t.driverDataNotFound);
        get(
            dispatch,
            driversResetMobileAppKeyRoute,
            { kierowca_id: id },
            response => {
                newDriver.kierowca_klucz_mobilny = response.data[1].klucz;
                dispatch({
                    type: type.SET_DRIVER_MOBILE_APP_KEY,
                    value: newDriver
                });
            }
        );
    };
};
